import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

/**
 * 모바일 미리보기: 별도 iframe 문서에 포털로 렌더링합니다.
 * Tailwind 등 `@media (min-width: …)` 분기는 부모 창이 아니라 iframe의 레이아웃 뷰포트(폭)를 따릅니다.
 */
export default function PersonalLandingMobilePreviewIframe({ children }) {
  const iframeRef = useRef(null)
  const [mountNode, setMountNode] = useState(null)
  const [frameHeight, setFrameHeight] = useState(520)

  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe) return undefined

    const handleLoad = () => {
      const idoc = iframe.contentDocument
      if (!idoc) return

      idoc.open()
      idoc.write('<!DOCTYPE html><html><head><meta charset="utf-8"/></head><body style="margin:0;background:#ffffff;"></body></html>')
      idoc.close()

      if (typeof document !== 'undefined') {
        idoc.documentElement.className = document.documentElement.className
        idoc.documentElement.lang = document.documentElement.lang || 'ko'
      }

      const head = idoc.head
      const viewport = idoc.createElement('meta')
      viewport.setAttribute('name', 'viewport')
      viewport.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover')
      head.appendChild(viewport)

      if (typeof document !== 'undefined') {
        document.querySelectorAll('link[rel="stylesheet"], style').forEach((el) => {
          head.appendChild(el.cloneNode(true))
        })
      }

      setMountNode(idoc.body)
    }

    iframe.addEventListener('load', handleLoad)
    iframe.src = 'about:blank'

    return () => {
      iframe.removeEventListener('load', handleLoad)
      setMountNode(null)
    }
  }, [])

  useEffect(() => {
    if (!mountNode) return undefined
    const measure = () => {
      const h = mountNode.scrollHeight
      setFrameHeight(Math.max(280, Math.min(h || 520, 16000)))
    }
    measure()
    if (typeof ResizeObserver === 'undefined') return undefined
    const ro = new ResizeObserver(measure)
    ro.observe(mountNode)
    const ch = window.setTimeout(measure, 300)
    const ch2 = window.setTimeout(measure, 900)
    return () => {
      ro.disconnect()
      window.clearTimeout(ch)
      window.clearTimeout(ch2)
    }
  }, [mountNode, children])

  return (
    <div className="w-full">
      <iframe
        ref={iframeRef}
        title="모바일 미리보기"
        className="mx-auto block w-full max-w-[390px] rounded-[28px] border-0 shadow-lg ring-2 ring-slate-800/10"
        style={{ height: frameHeight, minHeight: 280, maxHeight: 'min(85vh, 960px)' }}
      />
      {mountNode ? createPortal(children, mountNode) : null}
    </div>
  )
}
